// Tiny hook for the status-bar dot — subscribes to the shared trade WS
// connection state without re-rendering on every trade message.

import { useSyncExternalStore } from 'react';
import { subscribeStatus } from './tradeStream';

let cachedConnected = false;
let cachedConnectedRef = { value: false };

function subscribe(cb) {
  return subscribeStatus((connected) => {
    cachedConnected = connected;
    cachedConnectedRef = { value: connected };
    cb();
  });
}
function getSnapshot() {
  return cachedConnectedRef;
}

export function useTradeStreamConnected() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot).value;
}
